import { render, staticRenderFns } from "./PurchaseKO.vue?vue&type=template&id=6e342ec5&"
import script from "./PurchaseKO.vue?vue&type=script&lang=js&"
export * from "./PurchaseKO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports